<template>
	<div class="row m-0 p-0">
		<div>
			<div class="col-md-12 p-0">
				<div class="row bg-white">
					<div class="col-md-12 pt-3 py-1">
						<strong><span style="color:#303133;">CUSTOMER REPORT</span></strong>
					</div>
				</div>
				<div class="row">
					<div class="col-md-12 px-0">
						<el-tabs v-model="activeName" @tab-click="handleClick">
							<el-tab-pane name="topup-tertinggi">
								<span slot="label"><i class="el-icon-data-line"></i> Topup Tertinggi</span>
								<div class="px-0 tab-container-item" :style="{ 'height': screenHeight + 'px' }">
									<CustomerReportTab :tabIndex="0" :tabName="'topup-tertinggi'" :tabLabel="'Topup Tertinggi'"/>
								</div>
							</el-tab-pane>
							<el-tab-pane name="transaksi-tertinggi">
								<span slot="label"><i class="el-icon-data-line"></i> Transaksi Tertinggi</span>
								<div class="px-0 tab-container-item" :style="{ 'height': screenHeight + 'px' }">
									<CustomerReportTab :tabIndex="0" :tabName="'transaksi-tertinggi'" :tabLabel="'Transaksi Tertinggi'"/>
								</div>
							</el-tab-pane>
							<el-tab-pane name="berlangganan">
								<span slot="label"><i class="el-icon-data-line"></i> Berlangganan</span>
								<div class="px-0 tab-container-item" :style="{ 'height': screenHeight + 'px' }">
									<CustomerReportTab :tabIndex="0" :tabName="'berlangganan'" :tabLabel="'Berlangganan'"/>
								</div>
							</el-tab-pane>
						</el-tabs>
					</div>
				</div>

			</div>
		</div>
	</div>
</template>

<script>
import BarCard from '@/views/pages/BarCard.vue'
import ListItem from '@/views/pages/ListItem.vue'
import ListCompare from '@/views/pages/ListCompare.vue'
import Fuel from '@/components/page/Fuel.js'
import Footer from '@/views/Footer.vue'
import PieChart from '@/components/chart/Pie.js'
import { Config,Penanggalan,AxiosWithJar, FuelColor, Rainbow, Rainbow2 } from '@/utility.js'
import $ from 'jquery';

import CustomerReportTab from '@/views/pages/Customer/Component/CustomerReportTab.vue'

export default{
	extends: Fuel,
	components:{
		CustomerReportTab,
		//ListItem,
		//ListCompare,
		//BarCard,
		//PieChart,
		//Footer            
	},
	data(){
		return {
            value: 0,
			activeName: 'topup-tertinggi',

			outterheight: 160,
			screenHeight: window.innerHeight - 160,
		}
	},
	watch: {

	}, 
	computed:{

	},

    mounted(){
		this.$emit('childrenRoute');
		this.addTabNavClass();
		window.addEventListener('resize', this.setDivHeight);
    },
	beforeDestroy() {
        window.removeEventListener('resize', this.setDivHeight);
    },
    methods:{
		setDivHeight() {
          this.screenHeight = window.innerHeight - this.outterheight;
        },
		addTabNavClass() {
			$(".el-tabs__nav-wrap").addClass("bg-white");
			$(".el-tabs__header").addClass("tab-nav");
		},
		handleClick(tab, event) {
			console.log(tab, event);
		}
	}
}
</script>

<style>
.tab-nav {
	background: #ffffff !important;
	margin-bottom: 0px !important;
}

.tab-container-item {
    overflow-y: auto;
    overflow-x: hidden;
}
</style>